import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import EmptyParties from 'assets/images/empty_parties.png';
import { TFunction } from 'i18next';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: theme.spacing(40),
    padding: theme.spacing(6, 2),
    border: `1px solid ${theme.palette.border.card}`,
    borderRadius: 4,
    boxShadow: 'none',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 420,
    textAlign: 'center',
  },
  image: {
    width: theme.spacing(10),
    height: 'auto',
    marginBottom: theme.spacing(2),
  },
  title: {
    color: theme.palette.tab.offselected,
    marginBottom: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
  },
}));

type EmptyContainerProps = {
  t: TFunction;
};

const EmptyContainer: FC<EmptyContainerProps> = ({ t }) => {
  const classes = useStyles();

  return (
    <Paper variant="outlined" className={classes.paper}>
      <Box className={classes.content}>
        <img src={EmptyParties} alt="" className={classes.image} />
        <Typography variant="h5" component="h2" className={classes.title}>
          {t('parties:not-selected')}
        </Typography>
        <Typography variant="body2" className={classes.label}>
          {t('parties:not-selected-label')}
        </Typography>
      </Box>
    </Paper>
  );
};

export default EmptyContainer;
